import { SET_CUSTOM_ROUTES } from './custom-routes-actions';

type State = any;

export default function customRoutes(state: State = null, { type, payload }: any): State {
  switch (type) {
    case SET_CUSTOM_ROUTES:
      return payload;

    default:
      return state;
  }
}
